/**
 * Requirement-scoped collection work (tasks + nested materials) for ICR/EEI pages.
 */
const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function apiFetch(path, opts = {}) {
    const resp = await fetch(`${BASE}${path}`, {headers: authHeaders(), ...opts});
    if (resp.status === 404) return null;
    if (!resp.ok) {
        let detail = `${opts.method || 'GET'} ${path} → ${resp.status}`;
        try {
            const body = await resp.json();
            if (body?.error) detail = body.error;
            else if (body?.message) detail = body.message;
        } catch {
            /* ignore */
        }
        throw new Error(detail);
    }
    if (resp.status === 204) return null;
    return resp.json();
}

/**
 * @param {'icr'|'eei'} entityType
 * @param {string} entityId
 */
export async function fetchRequirementCollectionWork(entityType, entityId) {
    if (!entityId) return null;
    const path = entityType === 'eei'
        ? `/api/eeis/${encodeURIComponent(entityId)}/collection-work`
        : `/api/intelligence-requests/${encodeURIComponent(entityId)}/collection-work`;
    return apiFetch(path);
}
